import { cx } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'

import * as styles from './product-info-price-ds.styles'

export interface FinalSaleChipProps {
  showNewPdpDesignV2?: boolean
  isVariantThirdParty?: boolean
  variant: 'standard' | 'b2b'
}

// Final-sale chip with two variants: `standard` (in-column, optional 3P modifier) and `b2b` (after the main column).
function FinalSaleChip({ showNewPdpDesignV2, isVariantThirdParty, variant }: FinalSaleChipProps) {
  const { t } = useTranslation('common')
  const isThirdPartyStandard = variant === 'standard' && !!isVariantThirdParty
  // cva variant merge is deterministic (variant overrides base) so the 3P override wins.
  const finalSaleClass = styles.finalSaleChipRecipe({ thirdParty: isThirdPartyStandard })
  return (
    <div
      className={cx(
        finalSaleClass,
        showNewPdpDesignV2 && styles.priceWrapperMainFinalSaleNewDesignV2Css,
        variant === 'b2b' && styles.b2bFinalSaleTextWrapperCss,
      )}
    >
      <span>{t('final_sale')} </span>
    </div>
  )
}

export default FinalSaleChip
